// extracted by mini-css-extract-plugin
export default {"subordianteContainer":"styles_subordianteContainer__uW1I5"};